const module = { name: 'desktop/shared/pagination', exports: {} }; const exports = module.exports;



import { global_utils_functionUtils as global_utils_functionUtils_noop } from 'require-global';

const { noop } = global_utils_functionUtils_noop;


import { global_consts as global_consts_QueryParams } from 'require-core';

const { QueryParams } = global_consts_QueryParams;


import { Fandango_queryUtil as Fandango_queryUtil_setParam } from 'require-core';

const { setParam } = Fandango_queryUtil_setParam;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_sanitizer as sanitizer } from 'require-core';



import { Fandango_util as util } from 'require-global';



const Selectors = {
    HTML_BODY: 'html, body',
    PAGE_BTN: '.js-page-btn',
}


let notifyClick
function onClick(bypassClientLoading, e) {
    e.preventDefault();
    $(Selectors.HTML_BODY).scrollTop(0);
    const { page } = e.currentTarget.dataset;
    const url = window.location.pathname + '?' + sanitizer.url(setParam(QueryParams.PAGE, page, window.location.search));
    if (!window.history || bypassClientLoading) {
        util.navigate(url);
        return;
    }
    window.history.pushState({ path: url }, '', url);
    notifyClick(page);
    if (window.mps) {
        window.mps.refreshAds();
    }
}
function attach(opts) {
    const { onChange, bypassClientLoading } = opts || {};
    notifyClick = noop(onChange);
    $(Selectors.PAGE_BTN).on('click', onClick.bind(this, bypassClientLoading));
}
module.exports = {
    attach
};
export default module.exports;